import { useState } from "react";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import { quizzes } from "../data/quizData";

function Quiz() {
    const [methodId, setMethodId] = useState(null);
    const [name, setName] = useState("");
    const [answers, setAnswers] = useState({});
    const [submitted, setSubmitted] = useState(false);

    const quiz = methodId ? quizzes[methodId] : null;
    const total = quiz ? quiz.questions.length : 0;
    const correct = quiz ? quiz.questions.reduce((acc, q, i) => acc + (answers[i] === q.correct ? 1 : 0), 0) : 0;
    const percent = total ? Math.round((correct / total) * 100) : 0;
    const passed = percent >= 80;

    const reset = () => {
        setMethodId(null);
        setAnswers({});
        setSubmitted(false);
    };

    const generateCertificate = () => {
        const doc = new jsPDF({ orientation: "landscape", format: "a4" });

        // Ramka
        doc.setDrawColor(255, 182, 6);
        doc.setLineWidth(2);
        doc.rect(10, 10, 277, 190);
        doc.setLineWidth(0.5);
        doc.rect(15, 15, 267, 180);

        // Sarlavha
        doc.setFontSize(28);
        doc.setTextColor(255, 182, 6);
        doc.setFont(undefined, "bold");
        doc.text("SERTIFIKAT", 148.5, 45, { align: "center" });

        doc.setFontSize(12);
        doc.setTextColor(100);
        doc.setFont(undefined, "normal");
        doc.text("Mushtariy ta'lim platformasi tomonidan beriladi", 148.5, 55, { align: "center" });

        // Asosiy matn
        doc.setFontSize(14);
        doc.setTextColor(50);
        doc.text("Ushbu sertifikat", 148.5, 80, { align: "center" });

        doc.setFontSize(24);
        doc.setTextColor(0);
        doc.setFont(undefined, "bold");
        doc.text(name || "Foydalanuvchi", 148.5, 95, { align: "center" });

        doc.setFontSize(14);
        doc.setTextColor(50);
        doc.setFont(undefined, "normal");
        doc.text(`tomonidan "${quiz.title}" bo'yicha bilim testi`, 148.5, 110, { align: "center" });
        doc.text(`muvaffaqiyatli topshirilganligini tasdiqlaydi.`, 148.5, 120, { align: "center" });

        // Natija
        doc.setFontSize(18);
        doc.setTextColor(255, 182, 6);
        doc.setFont(undefined, "bold");
        doc.text(`Natija: ${percent}% (${correct}/${total})`, 148.5, 140, { align: "center" });

        // Sana
        doc.setFontSize(11);
        doc.setTextColor(80);
        doc.setFont(undefined, "normal");
        const date = new Date().toLocaleDateString("uz-UZ");
        doc.text(`Sana: ${date}`, 40, 175);
        doc.text("Mushtariy platformasi", 230, 175);

        doc.setFontSize(9);
        doc.setTextColor(150);
        doc.text(`Sertifikat ID: MSH-${Date.now()}`, 148.5, 185, { align: "center" });

        doc.save(`sertifikat_${methodId}_${Date.now()}.pdf`);
    };

    // Metod tanlash ekrani
    if (!methodId) {
        return (
            <>
                <section className="page-header">
                    <div className="container">
                        <div className="page-header__content">
                            <ul className="eduhive-breadcrumb list-unstyled">
                                <li><span className="eduhive-breadcrumb__icon"><i className="icon-home"></i></span><Link to="/">Bosh sahifa</Link></li>
                                <li><span>Bilim testi</span></li>
                            </ul>
                            <h2 className="page-header__title">Bilim testi va sertifikat</h2>
                        </div>
                    </div>
                </section>
                <section className="pricing-one section-space-bottom">
                    <div className="container">
                        <div className="pricing-one__main-tab-box tabs-box">
                            <div className="pricing-one__top">
                                <div className="pricing-one__content">
                                    <h3 className="pricing-one__title">Metod tanlang</h3>
                                    <p className="pricing-one__text">
                                        Har bir metod uchun alohida test. 80%+ ball — yuklab olinadigan sertifikat.
                                    </p>
                                </div>
                            </div>
                            <div className="pricing-one__inner px-3 px-lg-5">
                                <div className="row gutter-y-30">
                                    {Object.keys(quizzes).map((id) => (
                                        <div className="col-md-6 col-lg-4" key={id}>
                                            <div className="pricing-one__card" style={{ cursor: "pointer" }} onClick={() => setMethodId(id)}>
                                                <h3 className="pricing-one__card__title">{quizzes[id].title}</h3>
                                                <p className="pricing-one__card__text">
                                                    {quizzes[id].questions.length} ta savol
                                                </p>
                                                <button className="eduhive-btn" style={{ border: "none" }}>
                                                    <span>Testni boshlash</span>
                                                    <span className="eduhive-btn__icon">
                                                        <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }

    // Natija ekrani
    if (submitted) {
        return (
            <section className="pricing-one section-space">
                <div className="container">
                    <div className="pricing-one__main-tab-box tabs-box">
                        <div className="pricing-one__inner px-3 px-lg-5 text-center" style={{ padding: "60px 20px" }}>
                            <div style={{ fontSize: "80px", color: passed ? "#10b981" : "#ef4444" }}>
                                <i className={passed ? "icon-check" : "icon-cross"}></i>
                            </div>
                            <h2 style={{ marginTop: "20px" }}>{passed ? "Tabriklaymiz!" : "Afsuski, qayta urinib ko'ring"}</h2>
                            <h1 style={{ fontSize: "60px", color: "#ffb606", margin: "20px 0" }}>{percent}%</h1>
                            <p style={{ fontSize: "18px" }}>To'g'ri javoblar: <strong>{correct} / {total}</strong></p>
                            <p style={{ color: "#666" }}>
                                {passed
                                    ? "Siz testni muvaffaqiyatli topshirdingiz. Sertifikatni yuklab oling."
                                    : "Sertifikat olish uchun kamida 80% to'g'ri javob kerak."}
                            </p>
                            <div className="d-flex justify-content-center" style={{ gap: "15px", marginTop: "30px", flexWrap: "wrap" }}>
                                {passed && (
                                    <button onClick={generateCertificate} className="eduhive-btn" style={{ border: "none" }}>
                                        <span>Sertifikatni yuklab olish</span>
                                        <span className="eduhive-btn__icon">
                                            <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                        </span>
                                    </button>
                                )}
                                <button onClick={reset} className="eduhive-btn" style={{ border: "none", background: "#666" }}>
                                    <span>Boshqa testni tanlash</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    // Test ekrani
    return (
        <>
            <section className="page-header">
                <div className="container">
                    <div className="page-header__content">
                        <ul className="eduhive-breadcrumb list-unstyled">
                            <li><span className="eduhive-breadcrumb__icon"><i className="icon-home"></i></span><Link to="/">Bosh sahifa</Link></li>
                            <li><span>{quiz.title} testi</span></li>
                        </ul>
                        <h2 className="page-header__title">{quiz.title} — Test</h2>
                    </div>
                </div>
            </section>
            <section className="pricing-one section-space-bottom">
                <div className="container">
                    <div className="pricing-one__main-tab-box tabs-box">
                        <div className="pricing-one__inner px-3 px-lg-5">
                            <div className="mb-4">
                                <label className="d-block mb-2"><strong>Familya, Ism (sertifikat uchun)</strong></label>
                                <input
                                    type="text"
                                    placeholder="masalan: Aliyev Vali"
                                    className="form-control"
                                    style={{ padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%", maxWidth: "500px" }}
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>

                            {quiz.questions.map((q, i) => (
                                <div key={i} style={{
                                    background: "#fafafa",
                                    padding: "20px",
                                    borderRadius: "12px",
                                    marginBottom: "20px",
                                    borderLeft: "4px solid #ffb606"
                                }}>
                                    <h4 style={{ marginBottom: "15px" }}>{i + 1}. {q.q}</h4>
                                    {q.options.map((opt, oi) => (
                                        <label key={oi} style={{
                                            display: "block",
                                            padding: "10px 15px",
                                            margin: "5px 0",
                                            background: answers[i] === oi ? "#ffb606" : "#fff",
                                            color: answers[i] === oi ? "#fff" : "#333",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                            border: "1px solid #e5e5e5",
                                            transition: "all 0.2s"
                                        }}>
                                            <input
                                                type="radio"
                                                name={`q${i}`}
                                                checked={answers[i] === oi}
                                                onChange={() => setAnswers({ ...answers, [i]: oi })}
                                                style={{ marginRight: "10px" }}
                                            />
                                            {opt}
                                        </label>
                                    ))}
                                </div>
                            ))}

                            <div className="text-center mt-5">
                                <button
                                    onClick={() => setSubmitted(true)}
                                    disabled={Object.keys(answers).length < total || !name.trim()}
                                    className="eduhive-btn"
                                    style={{
                                        border: "none",
                                        opacity: (Object.keys(answers).length < total || !name.trim()) ? 0.5 : 1
                                    }}
                                >
                                    <span>Yakunlash va natijani ko'rish</span>
                                    <span className="eduhive-btn__icon">
                                        <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Quiz;
